import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import MeditationService from '../meditationService';

const prefix = 'MEDITATION_FORM';

const meditationFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: meditationFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await MeditationService.find(id);
      }

      dispatch({
        type: meditationFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: meditationFormActions.INIT_ERROR,
      });

      getHistory().push('/meditation');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: meditationFormActions.CREATE_STARTED,
      });

      const record = await MeditationService.create(
        values,
      );

      dispatch({
        type: meditationFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.meditation.create.success'),
      );

      getHistory().push(`/meditation/${record.id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: meditationFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: meditationFormActions.UPDATE_STARTED,
      });

      await MeditationService.update(id, values);

      dispatch({
        type: meditationFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.meditation.update.success'),
      );

      getHistory().push(`/meditation/${id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: meditationFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default meditationFormActions;
